import ArtworkTypesService from '@/services/codebooks/ArtworkTypesService'

export default {
  namespaced: true,
  state: {
    artworkTypesList: []
  },
  getters: {
    artworkTypesList: state => state.artworkTypesList
  },
  actions: {
    refreshArtworkTypes ({ commit }) {
      return ArtworkTypesService.getAllArtworkTypes()
        .then(list => {
          commit('SET_ARTWORK_TYPES', list)
        })
    },
    addNewArtworkType ({ commit }, artworkType) {
      return ArtworkTypesService.saveArtworkType(artworkType).then(result => {
        artworkType.id = result.data
        commit('ADD_ARTWORK_TYPE', artworkType)
        return artworkType
      })
    },
    editArtworkType ({ commit }, artworkType) {
      return ArtworkTypesService.saveArtworkType(artworkType).then(result => {
        commit('EDIT_ARTWORK_TYPE', artworkType)
        return artworkType
      })
    },
    deleteArtworkType ({ commit }, artworkType) {
      return ArtworkTypesService.removeArtworkType(artworkType).then(result => {
        commit('DELETE_ARTWORK_TYPE', artworkType)
      })
    }
  },
  mutations: {
    SET_ARTWORK_TYPES (state, list) {
      state.artworkTypesList = list
    },
    EDIT_ARTWORK_TYPE (state, artworkType) {
      const current = state.artworkTypesList[artworkType.index]
      current.name = artworkType.name
      current.code = artworkType.code
    },
    ADD_ARTWORK_TYPE (state, artworkType) {
      const newArtworkType = {
        id: artworkType.id,
        name: artworkType.name,
        code: artworkType.code
      }
      state.artworkTypesList.push(newArtworkType)
    },
    DELETE_ARTWORK_TYPE (state, artworkType) {
      state.artworkTypesList.splice(artworkType.index, 1)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/codebook/artworkTypes.js